import axios from "axios";
const baseURL = "http://mcqueen.markematics.net/McQueenV2.svc";

const http = axios.create({ baseURL });

export default http;
